import { render } from "./ProductRecommendations.vue?vue&type=template&id=7dca2f58&scoped=true"
import script from "./ProductRecommendations.vue?vue&type=script&lang=js"
export * from "./ProductRecommendations.vue?vue&type=script&lang=js"

import "./ProductRecommendations.vue?vue&type=style&index=0&id=7dca2f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dca2f58"]])

export default __exports__